import { reportApi } from "../../app/reportApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import {
  GetReportQueryParams,
  GetReportResponseType,
} from "../../types/report";

export const reportsApi = reportApi.injectEndpoints({
  endpoints: (builder) => ({
    getReportList: builder.query<
      GetReportResponseType,
      GetQueryArgsType<GetReportQueryParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getReportList,
        ...queryArgs,
      }),
      providesTags: ["GetReport"],
    }),

    generateCustomAttendanceReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.customAttendanceReportReq,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    customAttendanceReportReqOnlyTime: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.customAttendanceReportReqOnlyTime,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    dailyAttendanceReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.dailyAttendanceReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    customAttendanceReportByEmployee: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.customAttendanceReportByEmployee,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    employeeReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.employeeReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    disbursedPayslip: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.disbursedPayslip,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    overtimeSummary: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.overtimeSummary,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    payReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.payReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    payReportDetails: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.payReportDetails,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    departmentWiseSalaryReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.departmentWiseSalaryReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    downloadTaxReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.downloadTaxReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    leaveApplicationReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.leaveApplicationReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    employeeLeaveBalanceDetailsReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.employeeLeaveBalanceDetailsReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    getExpenseDetailsReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.getExpenseDetailsReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    getExpenseReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.getExpenseReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    getVisitReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.getVisitReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    trackingDetailsReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.trackingDetailsReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    supportListReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.supportListReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    shiftAssignListReport: builder.mutation({
      query: (queryArgs) => ({
        url: API_URL.shiftAssignListReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
  }),
});

export const {
  useGetReportListQuery,
  useGenerateCustomAttendanceReportMutation,
  useCustomAttendanceReportReqOnlyTimeMutation,
  useDailyAttendanceReportMutation,
  useCustomAttendanceReportByEmployeeMutation,
  useEmployeeReportMutation,
  useDisbursedPayslipMutation,
  useOvertimeSummaryMutation,
  usePayReportMutation,
  usePayReportDetailsMutation,
  useDepartmentWiseSalaryReportMutation,
  useDownloadTaxReportMutation,
  useLeaveApplicationReportMutation,
  useEmployeeLeaveBalanceDetailsReportMutation,
  useGetExpenseDetailsReportMutation,
  useGetExpenseReportMutation,
  useGetVisitReportMutation,
  useTrackingDetailsReportMutation,
  useSupportListReportMutation,
  useShiftAssignListReportMutation,
} = reportsApi;
